var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChatIconDesktop(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 209.9,
    height: 240.018,
    viewBox: "0 0 209.9 240.018",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "orvosi_chat_ikon_desktop",
    transform: "translate(-655.439 -549.579)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11015",
    d: "M722.669,579.475h21.377V681.528H700.9l33.775,29.221",
    transform: "translate(116.293 75.067)",
    fill: "none",
    stroke: "#1fba9c",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11016",
    d: "M670.816,591.972v53.633H751.9",
    transform: "translate(29.825 110.99)",
    fill: "none",
    stroke: "#1fba9c",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11017",
    d: "M739.048,582.6h81.089V684.628h-159.7V582.6h43.138L669.81,553.358",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#1fba9c",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1062",
    x2: 12.238,
    transform: "translate(736.659 634.413)",
    fill: "none",
    stroke: "#1fba9c",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1063",
    x2: 12.238,
    transform: "translate(766.702 634.413)",
    fill: "none",
    stroke: "#1fba9c",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1064",
    x2: 12.238,
    transform: "translate(706.616 634.413)",
    fill: "none",
    stroke: "#1fba9c",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1065",
    x2: 12.238,
    transform: "translate(772.823 710.788)",
    fill: "none",
    stroke: "#1fba9c",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1066",
    x2: 12.238,
    transform: "translate(802.862 710.788)",
    fill: "none",
    stroke: "#1fba9c",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1067",
    x2: 12.238,
    transform: "translate(742.781 710.788)",
    fill: "none",
    stroke: "#1fba9c",
    strokeWidth: 10
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatIconDesktop);
export default __webpack_public_path__ + "static/media/ChatIconDesktop.f85b62db8b8f36c81b362b2eb231f33e.svg";
export { ForwardRef as ReactComponent };